import { HubExchangeAccount } from "@cede/types";
import { create } from "zustand";

type AutoRemoveExchangeAccountStore = {
  open: boolean;
  setOpen: (open: boolean) => void;
  exchangeAccountToRemove: HubExchangeAccount | null;
  setExchangeAccountToRemove: (exchangeAccount: HubExchangeAccount | null) => void;
};

export const useAutoRemoveExchangeAccountStore = create<AutoRemoveExchangeAccountStore>((set) => ({
  open: false,
  setOpen: (open: boolean) => set({ open }),
  exchangeAccountToRemove: null,
  setExchangeAccountToRemove: (exchangeAccount: HubExchangeAccount | null) =>
    set({ exchangeAccountToRemove: exchangeAccount }),
}));
